const MONO_PALETTE = [
  [35, 25, 45]
];
const DUO_PALETTE = [
  [35, 25, 45],
  [35, 25, 45],
  [245, 215, 215]
];

export function ApplyCanvas(difficulty, canvas, image){
  switch(difficulty){
    case 'easy':  
      ApplyEasy(canvas, image);
      break;  
    case 'medium':
      ApplyMedium(canvas, image);
      break;
    case 'hard':
      ApplyHard(canvas, image);
      break;
    default:
      ApplyEasy(canvas, image);
      break;
  }
}
export function ApplyEasy(canvas, image){
  canvas.classList.remove("animate-updown");
  canvas.style.filter = 'brightness(100%)';
  BasicImage(canvas, image);
  setTimeout(() => {
    canvas.classList.add("animate-updown");
  }, 0);
}
export function ApplyPaletteHint(canvas){

    ApplyGameBoyPalette(canvas, DUO_PALETTE);
    console.log('Palette applied, filter is:', canvas.style.filter);
}
export function ApplyMedium(canvas, image){
  canvas.classList.remove("animate-updown");
  BasicImage(canvas, image);
  canvas.style.filter = 'brightness(100%)';
  ApplyGameBoyPalette(canvas, MONO_PALETTE);
  setTimeout(() => {
    canvas.classList.add("animate-updown");
  }, 0);
}
export function ApplyHard(canvas, image){
  canvas.classList.remove("animate-updown");
  const choice =  Math.floor(Math.random() * 5);
  switch(choice){
    case 0:
        GridImage(canvas, image);
        break;
      case 1:
        TwirlImage(canvas, image);
        break;
      case 2:
        WaveImage(canvas, image);
        break;
      case 3:
        VertImage(canvas, image);
        break;
      case 4:
        HorzImage(canvas, image);
        break;
      default:
        FishImage(canvas, image);
        break;
  }
  canvas.style.filter = 'brightness(100%)';
  ApplyGameBoyPalette(canvas, MONO_PALETTE);
  setTimeout(() => {
    canvas.classList.add("animate-updown");
  }, 0);
}

function BasicImage(canvas, image){
  const ctx = canvas.getContext('2d',{ willReadFrequently: true });
  canvas.width = image.width;
  canvas.height = image.height;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(image, 0, 0);
}
function FishImage(canvas, image){
  const ctx = canvas.getContext('2d');
  canvas.width = image.width;
  canvas.height = image.height;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  ctx.drawImage(image, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;
  const newPixels = new Uint8ClampedArray(pixels.length);

  // fish eye params
  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  const radius = Math.min(centerX, centerY);
  const strength = 2.5;

  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const dx = x - centerX;
      const dy = y - centerY;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance < radius) {
          const r = distance / radius;
          const newR = Math.pow(r, strength) * radius;
          const angle = Math.atan2(dy, dx);

          const newX = Math.floor(centerX + newR * Math.cos(angle));
          const newY = Math.floor(centerY + newR * Math.sin(angle));

          const originalIndex = (newY * canvas.width + newX) * 4;
          const newIndex = (y * canvas.width + x) * 4;

          newPixels[newIndex] = pixels[originalIndex];     
          newPixels[newIndex + 1] = pixels[originalIndex + 1]; 
          newPixels[newIndex + 2] = pixels[originalIndex + 2]; 
          newPixels[newIndex + 3] = pixels[originalIndex + 3]; 
        } 
      else {
        const index = (y * canvas.width + x) * 4;
        newPixels[index] = pixels[index];
        newPixels[index + 1] = pixels[index + 1];
        newPixels[index + 2] = pixels[index + 2];
        newPixels[index + 3] = pixels[index + 3];
      }
    }
  }

  imageData.data.set(newPixels);
  ctx.putImageData(imageData, 0, 0);
}

function GridImage(canvas, image){
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  canvas.width = image.width;
  canvas.height = image.height;


  ctx.drawImage(image, 0, 0);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;
  const newPixels = new Uint8ClampedArray(pixels.length);

  const gridSize = image.width / 6;

  const w = canvas.width;
  const h = canvas.height;

  for(let y = 0; y < h; y++){
    const gridY = Math.floor(y / gridSize);
    for(let x = 0; x < w; x++){
      const gridX = Math.floor(x / gridSize);
      const index = (y * w + x) * 4;
      
      if((gridX + gridY) % 2 === 0){
        newPixels[index] = pixels[index];
        newPixels[index + 1] = pixels[index + 1];
        newPixels[index + 2] = pixels[index + 2];
        newPixels[index + 3] = pixels[index + 3];
      }
      else{
        newPixels[index] = 0;
        newPixels[index + 1] = 0;
        newPixels[index + 2] = 0;
        newPixels[index + 3] = 0;
      }
    }
  }
  imageData.data.set(newPixels);
  ctx.putImageData(imageData, 0, 0);
}
function HorzImage(canvas, image){
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  canvas.width = image.width;
  canvas.height = image.height;


  ctx.drawImage(image, 0, 0);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;
  const newPixels = new Uint8ClampedArray(pixels.length);

  const gridSize = image.width / 24;

  const w = canvas.width;
  const h = canvas.height;

  for(let y = 0; y < h; y++){
    const gridY = Math.floor(y / gridSize);
    for(let x = 0; x < w; x++){
      const gridX = Math.floor(x / gridSize);
      const index = (y * w + x) * 4;
      
      if((gridY) % 3 === 0){
        newPixels[index] = pixels[index];
        newPixels[index + 1] = pixels[index + 1];
        newPixels[index + 2] = pixels[index + 2];
        newPixels[index + 3] = pixels[index + 3];
      }
      else{
        newPixels[index] = 0;
        newPixels[index + 1] = 0;
        newPixels[index + 2] = 0;
        newPixels[index + 3] = 0;
      }
    }
  }
  imageData.data.set(newPixels);
  ctx.putImageData(imageData, 0, 0);
}

function VertImage(canvas, image){
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  canvas.width = image.width;
  canvas.height = image.height;


  ctx.drawImage(image, 0, 0);
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;
  const newPixels = new Uint8ClampedArray(pixels.length);

  const gridSize = image.width / 24;

  const w = canvas.width;
  const h = canvas.height;

  for(let y = 0; y < h; y++){
    const gridY = Math.floor(y / gridSize);
    for(let x = 0; x < w; x++){
      const gridX = Math.floor(x / gridSize);
      const index = (y * w + x) * 4;
      
      if((gridX) % 3 === 0){
        newPixels[index] = pixels[index];
        newPixels[index + 1] = pixels[index + 1];
        newPixels[index + 2] = pixels[index + 2];
        newPixels[index + 3] = pixels[index + 3];
      }
      else{
        newPixels[index] = 0;
        newPixels[index + 1] = 0;
        newPixels[index + 2] = 0;
        newPixels[index + 3] = 0;
      }
    }
  }
  imageData.data.set(newPixels);
  ctx.putImageData(imageData, 0, 0);
}


function TwirlImage(canvas, image){
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  canvas.width = image.width;
  canvas.height = image.height;

  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = image.width;
  tempCanvas.height = image.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(image, 0, 0);

  const srcData = tempCtx.getImageData(0, 0, image.width, image.height);
  const destData = ctx.createImageData(image.width, image.height);

  // swirl params
  const centerX = image.width / 2;
  const centerY = image.height / 2;
  const radius = Math.min(image.width, image.height) / 2;
  const angleMultiplier =2; 

  let sign = 1;
  if(Math.floor(Math.random() * 2) === 0){
    sign = -1;
  };
  for (let y = 0; y < image.height; y++) {
    for (let x = 0; x < image.width; x++) {
      
      const distanceX = x - centerX;
      const distanceY = y - centerY;
      const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

      const destIndex = (y * image.width + x) * 4;
      
      if (true) {
        // Calculate the new angle for the pixel
        const angle = Math.atan2(distanceY, distanceX);
        const twist = (1 - (distance / radius)) * angleMultiplier;
        const newAngle = angle + twist * sign;

        // Calculate the new source coordinates
        const srcX = Math.floor(centerX + distance * Math.cos(newAngle));
        const srcY = Math.floor(centerY + distance * Math.sin(newAngle));

        // Check if the source coordinates are within the image bounds
        if (srcX >= 0 && srcX < image.width && srcY >= 0 && srcY < image.height) {
          const srcIndex = (srcY * image.width + srcX) * 4;
          
          // Copy pixel data
          destData.data[destIndex] = srcData.data[srcIndex];
          destData.data[destIndex + 1] = srcData.data[srcIndex + 1];
          destData.data[destIndex + 2] = srcData.data[srcIndex + 2];
          destData.data[destIndex + 3] = srcData.data[srcIndex + 3]; // Preserve original alpha
        } 
        else {
          // Handle pixels that map outside the original image boundary by making them transparent
          destData.data[destIndex + 3] = 0; // Set alpha to 0 (fully transparent)
        }
      } 
      else {
        // For pixels outside the swirl radius, copy the original pixel, including its transparency
        const srcIndex = (y * image.width + x) * 4;
        destData.data[destIndex] = srcData.data[srcIndex];
        destData.data[destIndex + 1] = srcData.data[srcIndex + 1];
        destData.data[destIndex + 2] = srcData.data[srcIndex + 2];
        destData.data[destIndex + 3] = srcData.data[srcIndex + 3]; // Preserve original alpha
      }
    }
  }

  // Put the new pixel data back on the canvas
  ctx.putImageData(destData, 0, 0);
};

function WaveImage(canvas, image){
  const ctx = canvas.getContext('2d',{ willReadFrequently: true });
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  canvas.width = image.width;
  canvas.height = image.height;

  ctx.drawImage(image, 0, 0);

  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const pixels = imageData.data;
  const newPixels = new Uint8ClampedArray(pixels.length);

  const centerX = canvas.width / 2;
  const centerY = canvas.height / 2;
  const radius = Math.min(centerX, centerY);
  const strength = 2.5;
  
  const amplitude = 32;  // strength of the wave
  const wavelength = 24; // distance between wave peaks

  for (let y = 0; y < canvas.height; y++) {
    for (let x = 0; x < canvas.width; x++) {
      const xOffset = Math.sin((y / wavelength) * 2 * Math.PI) * amplitude;
      const newX = Math.floor(x + xOffset);

      const newIndex = (y * canvas.width + x) * 4;

      if (newX >= 0 && newX < canvas.width) {
        const originalIndex = (y * canvas.width + newX) * 4;
        newPixels[newIndex] = pixels[originalIndex];
        newPixels[newIndex + 1] = pixels[originalIndex + 1];
        newPixels[newIndex + 2] = pixels[originalIndex + 2];
        newPixels[newIndex + 3] = pixels[originalIndex + 3];
      }
    }
  }
  imageData.data.set(newPixels);
  ctx.putImageData(imageData, 0, 0);
}

export function ApplyGameBoyPalette(canvas, palette) {
  const ctx = canvas.getContext("2d",{ willReadFrequently: true });
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  const numberofColors = palette.length;

  for (let i = 0; i < data.length; i += 4) {
    const r = data[i];
    const g = data[i + 1];
    const b = data[i + 2];
    const a = data[i + 3];

    const brightness = 0.299 * r + 0.587 * g + 0.114 * b;

    let paletteIndex = Math.floor((brightness / 256) *numberofColors);
    let alpha = 1;

    const [pr, pg, pb] = palette[paletteIndex];

    data[i]     = pr;
    data[i + 1] = pg;
    data[i + 2] = pb;
    data[i + 3] = alpha * a;
  }
  ctx.putImageData(imageData, 0, 0);
}

//ApplyHard();